import { Component } from '@angular/core'

@Component({
  selector: 'se-po-suffix-select-docs',
  templateUrl: './suffix-select-docs.component.html',
  styleUrls: ['./suffix-select-docs.component.scss'],
  standalone: false,
})
export class SuffixSelectDocsComponent {
}
